/**
 * Created by mac on 4/15/20
 */

Level.prototype.edit = function (callback) {
    cleverapps.focusManager.display({
        focus: "LevelPressedEditor",
        stack: true,
        actions: [
            (f) => {
                cleverapps.bundleLoader.loadBundle(this.bundleId(), {
                    onSuccess: () => {
                        this.setupContent();
                        f();
                    }
                });
            },

            (f) => this.loadStatistics(f),

            (f) => EditorScene.open({ level: this }, f),

            (f) => {
                f();

                if (callback) {
                    callback();
                }
            }
        ]
    });
};

Level.prototype.loadStatistics = function (f) {
    if (cleverapps.config.type === "merge" || cleverapps.config.type === "battlefield" || cleverapps.config.type === "tile3" || cleverapps.flags.norest) {
        f();
        return;
    }

    const episodeNo = LevelManager.getInstance().level.episodeNo;
    const levelNo = LevelManager.getInstance().level.levelNo;

    this.playedProductionMaxVersion = -1;

    if (typeof episodeNo !== "number" || typeof levelNo !== "number") {
        f();
        return;
    }

    cleverapps.RestClient.get(EpisodeStatistics.getStatisticsUrl({ episode: episodeNo, level: levelNo }), {}, (data) => {
        const versions = data.map((line) => line.version)
            .filter((version) => version !== undefined && version !== null)
            .map((version) => parseInt(version));

        this.playedProductionMaxVersion = Math.max(this.playedProductionMaxVersion, ...versions);

        f();
    });
};

if (typeof Loader !== "undefined") {
    if (Loader.prototype._loadNext === undefined) {
        Loader.prototype._loadNext = Loader.prototype.loadNext;
        Loader.prototype.loadNext = function (row, col, data, coordOnly) {
            let cell;

            if (cleverapps.environment.isEditorScene()) {
                if (data[0] === Loader.WILDCARD) {
                    cell = new EditorRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === BombCell.CODES[0] && data[2] === Loader.WILDCARD) {
                    cell = new EditorBombRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === FireworkCell.CODES[0] && data[2] === Loader.WILDCARD) {
                    cell = new EditorFireworkRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === WaffleCell.CODES[0] && data[1] === Loader.WILDCARD) {
                    cell = new EditorWaffleRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === TruffleCell.CODES[0] && (data[2] === Loader.WILDCARD || data[1] === Loader.WILDCARD)) {
                    cell = new EditorTruffleRandomCell(col, row, data[1]);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === LollipopCell.CODES[0] && data[1] === Loader.WILDCARD) {
                    cell = new EditorLollipopRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === BagDecoratorCell.CODES[0] && data[1] === Loader.WILDCARD) {
                    cell = new EditorBagDecoratorRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === ColorCookieManCell.CODES[0] && data[1] === Loader.WILDCARD) {
                    cell = new EditorColorCookieManRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === ColorBombCell.CODES[0] && data[2] === Loader.WILDCARD) {
                    cell = new EditorColorBombRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
                if (data[0] === SmallPetardCell.CODES[0] && data[2] === Loader.WILDCARD) {
                    cell = new EditorSmallPetardRandomCell(col, row);
                    cell.load(data, this);
                    return cell;
                }
            }

            return this._loadNext(row, col, data, coordOnly);
        };
    }
}
